import { useQuery } from '@tanstack/react-query'
import { Typography } from 'antd'
import invoiceApi from 'api/invoiceApi'
import ticketApi from 'api/ticketApi'
import dayjs from 'dayjs'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import ModalDataTransmissionLog from 'general/components/ModalDataTransmissionLog'
import {
  INVOICE_STATUS,
  RESOURCE_TYPE,
  TICKET_GRANTED_STATUS,
} from 'general/constants/AppConstants'
import SelectOptions from 'general/constants/SelectOptions'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import useExportById from 'hooks/Mutations/useExportById'
import useFilter from 'hooks/useFilter'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { queries } from './queries'
import './style.scss'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import ModalDataTransmissionLogAD from 'general/components/ModalDataTransmissionLog/modalDataTransmissionLogAD'
import { useDispatch } from 'react-redux'
import { thunkExportAccountingDocument } from 'features/AccountingDocument/accountDoucmentsSlice'

function ListTaxMessageAccountingDocuments() {
  // MARK --- Parmas: ---
  const systemType = useAppSelector((s) => s.auth.activeInvoice)
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const { t } = useTranslation()
  const [tranmissionModalShow, setTranmissionModalShow] = useState(false)
  const [activeInvoice, setActiveInvoice] = useState(null)
  // const [copy, setCopy] = useCopyToClipboard()
  // const hasCopied = Boolean(copy)
  const [filters, setFilters] = useFilter(
    'taxMessageInvoiceList',
    'gFilterListTaxMessageInvoice',
  )
  const { data: listData, isFetching: gettingTaxInvoice } = useQuery(
    queries.lists(filters, 'TNCN'),
  )
  const dispatch = useDispatch()
  // const { exportFunc } = useExportById(
  //   (id) =>
  //     systemType?.invoice
  //       ? invoiceApi.exportInvoiceById(id)
  //       : systemType?.ticket
  //         ? ticketApi.exportById(id)
  //         : invoiceApi.exportInvoiceById(id),
  //   'Hoá đơn điện tử.pdf',
  //   'application/pdf',
  // )
  const [inforItemTable, setInforItemTable] = useState({})
  const setDataInforItemTable = (
    inforItemTable,
    nameKey,
    key,
    value,
    disable,
  ) => {
    const inforItemTableTemp = {
      ...inforItemTable,
      [nameKey]: {
        ...inforItemTable?.[nameKey],
        [key]: value, // Dùng dynamic key
      },
      disable,
    }
    console.log(inforItemTableTemp)
    setInforItemTable(inforItemTableTemp)
  }

  const exportFile = async (typeFile, accounting_documentsId, view) => {
    const dataFile = await dispatch(
      thunkExportAccountingDocument({
        typeFile,
        accounting_documentsId,
      }),
    )
    if (typeFile == 'XML') {
      setDataInforItemTable(
        inforItemTable,
        'exportFileXML',
        accounting_documentsId,
        false,
      )
    } else {
      if (view) {
        setDataInforItemTable(
          inforItemTable,
          'exportFilePrin',
          accounting_documentsId,
          false,
        )
      } else {
        setDataInforItemTable(
          inforItemTable,
          'exportFilePDF',
          accounting_documentsId,
          false,
        )
      }
    }
    if (dataFile?.payload?.data && dataFile.payload.fileName) {
      const { data, fileName } = dataFile.payload
      if (data.type === 'Buffer') {
        const byteArray = new Uint8Array(data.data)
        const blob = new Blob([byteArray], {
          type: typeFile == 'XML' ? 'application/xml' : 'application/pdf',
        })
        if (view) {
          const url = URL.createObjectURL(blob)
          window.open(url, '_blank')
        } else {
          saveAs(blob, fileName)
        }
      } else {
        ToastHelper.showError('Invalid buffer data')
      }
    }
  }

  const columns = useMemo(() => {
    const arr = [
      {
        name: 'Tên thông điệp',
        center: true,
        cell: () => (
          <Typography.Text
            ellipsis={{
              tooltip: t('taxpayer.messageTn'),
            }}
          >
            {t('taxpayer.messageTn')}
          </Typography.Text>
        ),
      },
      {
        name: 'Ngày tạo',
        width: '120px',
        center: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.createDate ? dayjs(row?.createDate).format('L') : ''}
            </p>
          )
        },
      },
      {
        name: 'Tên',
        width: '120px',
        center: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.taxpayersName}
            </p>
          )
        },
      },
      {
        name: 'Mã số thuế',
        width: '120px',
        center: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.employeeTaxCode}
            </p>
          )
        },
      },
      {
        name: 'Số chứng từ',
        center: true,
        width: '120px',
        cell: (row) => {
          return (
            <Typography.Text className="m-0 mr-4">
              {row?.numberDocument}
            </Typography.Text>
          )
        },
      },
      {
        name: 'CCCD/HC',
        center: true,
        width: '150px',
        cell: (row) => {
          return (
            <Typography.Text className="m-0 mr-4">
              {row?.employeeIdentification}
            </Typography.Text>
          )
        },
      },
      // {
      //   name: 'Mã cơ quan thuế',
      //   center: true,
      //   minWidth: '250px',
      //   ignoreRowClick: true,
      //   cell: (row) => {
      //     if (!row?.taxAuthorityCode) return ''
      //     return (
      //       <Typography.Text className="m-0">
      //         {row?.taxAuthorityCode}
      //       </Typography.Text>
      //     )
      //   },
      // },
      {
        name: 'Trạng thái',
        center: true,
        width: '150px',
        cell: (row) => {
          const constStatus = findObjectInArray(
            SelectOptions.listStatusAccountingDocuments,
            'value',
            row.status,
          )
          console.log('constStatus', row.status)
          return (
            <div className="left-cell">
              <SpanNotYetReleasedTd
                color={constStatus?.color}
                backGroundColor={constStatus?.backGroundColor}
              >
                {constStatus?.label}
              </SpanNotYetReleasedTd>
            </div>
          )
        },
      },
      {
        name: '',
        grow: 0,
        center: true,
        compact: true,
        cell: (row) => {
          return (
            <>
              <TableAction
                icon={<IconAction className="fa-light fa-eye" />}
                titleActionText="Xem thông điệp"
                onClick={() => {
                  setActiveInvoice(row)
                  setTranmissionModalShow(true)
                }}
              />
              <TableAction
                //isLoading={inforItemTable?.disable}
                titleActionText="Xem chứng từ"
                icon={<IconAction className="fa-light fa-receipt" />}
                onClick={() => {
                  setInforItemTable({ ...inforItemTable, disable: true })
                  exportFile('PDF', row.accounting_documentsId, 1)
                }}
              />
            </>
          )
        },
      },
    ]
    return arr
  }, [])

  /** @type {FilterDefaultValueProp[]} */
  const defaultFilter = [
    systemType?.invoice
      ? {
          alias: 'Trạng thái phát hành',
          label: 'Trạng thái phát hành',
          formName: 'issueStatus',
          options: SelectOptions.taxMessageInvoiceStatus,
          value: null,
          colSpan: 'FULL',
        }
      : systemType?.ticket
        ? {
            alias: 'Trạng thái cấp mã',
            label: 'Trạng thái',
            formName: 'typeRelease',
            options: SelectOptions.ticketGrantedStatus,
            value: null,
            colSpan: 'FULL',
          }
        : {},
  ]

  useEffect(() => {
    setFilters({
      q: debouncedSearch,
      page: 1,
    })
  }, [debouncedSearch, setFilters])

  return (
    <ContentContainer wrapperClassName="list-replaced-invoice">
      <ContentContainer.Header
        titleContent={t('taxpayer.lstnchungtu')}
        description={`Tổng: ${Utils.formatNumber(listData?.total)} bản tin`}
        toolBar={
          <CustomAntInput
            type="search"
            borderRadius="sm"
            inputProps={{
              value: search,
              placeholder: t('taxpayer.keySearch'),
              onChange: (e) => {
                setSearch(e.target.value)
              },
            }}
            width={300}
          />
        }
      >
        {/* <FilterPopover
          menuPosition="bottomRight"
          defaultValues={defaultFilter}
          onApply={setFilters}
          savedKey="gFilterListTaxMessageInvoice"
        /> */}
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          columns={columns}
          dataSource={listData?.rows}
          isLoading={gettingTaxInvoice}
          isClickable
          handleDoubleClickRow={(row) => {
            setActiveInvoice(row)
            setTranmissionModalShow(true)
          }}
          pagination={{
            total: listData?.total,
            rowsPerPage: filters?.limit,
            currentPage:
              filters?.page === 0 ? filters?.page + 1 : filters?.page,
            onChangePage: (page) => setFilters({ page }),
            onChangeRowsPerPage: (limit) => setFilters({ limit, page: 1 }),
          }}
        />
      </ContentContainer.Body>
      <ModalDataTransmissionLogAD
        show={tranmissionModalShow}
        onHide={() => setTranmissionModalShow(false)}
        object={activeInvoice}
        isInvoice={!!systemType?.invoice}
      />
    </ContentContainer>
  )
}

export default ListTaxMessageAccountingDocuments
